var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", [
    _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.headers, function (header) {
          return _c("th", [
            _vm._v("\n        " + _vm._s(header.text) + "\n      "),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [_c("td", [_vm._v(_vm._s(_vm.$t("contentGoesHere")))])]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }